import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	style: {
		fill: "currentColor",
		transform: "",
		msfilter: ""
	},
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" }), /* @__PURE__ */ _jsx("path", { d: "M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z" })]
});
export default SvgTime;
